import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import React, { useState, useEffect } from "react";
import LoginScreen from "./components/LoginScreen"
import OtpVerificationPage from "./components/OtpVerification"
import DashboardScreen from "./components/DashboardScreen"
import AppointmentsScreen from "./components/AppointmentsScreen"
import PrivateRoute from "./Services/PrivateRoute"
// import "../src/index";
import "./App.css";
import "../src/styles/globals.css";
import AppointmentDetailsScreen from "./components/AppointmentDetailsScreen"
import SampleCollectionScreen from "./components/SampleCollectionScreen"
import CollectionSuccessScreen from "./components/CollectionSuccessScreen"
import AttendanceScreen from "./components/AttendanceScreen"
import LeaveApplicationScreen from "./components/LeaveApplicationScreen"
import AttendanceHistoryScreen from "./components/AttendanceHistoryScreen"
import NavigationScreen from "./components/NavigationScreen"
import HistoryScreen from "./components/HistoryScreen"
import NotificationsScreen from "./components/NotificationsScreen"
import ProfileScreen from "./components/ProfileScreen"
import SupportScreen from "./components/SupportScreen"
import CollectionReshedule from "./components/CollectionReshedule"
import HandoverDue from "./components/HandoverDue"
// import { getFCMToken, onMessageListener } from "../src/Services/firebase";
// import authService from "./Services/authService";
import { NotificationProvider } from "./Services/NotificationContext";

function App() {

  return (
    <NotificationProvider>
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/otp-verification" element={<OtpVerificationPage />} />
          <Route path="/" element={<PrivateRoute element={DashboardScreen} />} />
          <Route path="/dashboard" element={<PrivateRoute element={DashboardScreen} />} />
          <Route path="/appointments" element={<PrivateRoute element={AppointmentsScreen} />} />
          <Route path="/appointments/:id" element={<PrivateRoute element={AppointmentDetailsScreen} />} />
          <Route path="/appointments/:id/collect" element={<PrivateRoute element={SampleCollectionScreen} />} />
          <Route path="/appointments/:id/success" element={<PrivateRoute element={CollectionSuccessScreen} />} />
          <Route path="/appointments/:id/reshedule" element={<PrivateRoute element={CollectionReshedule} />} />
          <Route path="/attendance" element={<PrivateRoute element={AttendanceScreen} />} />
          <Route path="/attendance/leave" element={<PrivateRoute element={LeaveApplicationScreen} />} />
          <Route path="/attendance/history" element={<PrivateRoute element={AttendanceHistoryScreen} />} />
          <Route path="/navigate" element={<PrivateRoute element={NavigationScreen} />} />
          <Route path="/history" element={<PrivateRoute element={HistoryScreen} />} />
          <Route path="/notifications" element={<PrivateRoute element={NotificationsScreen} />} />
          <Route path="/profile" element={<PrivateRoute element={ProfileScreen} />} />
          <Route path="/support" element={<PrivateRoute element={SupportScreen} />} />
          <Route path="/navigate" element={<PrivateRoute element={NavigationScreen} />} />
          <Route path="/handover-amount" element={<PrivateRoute element={HandoverDue} />} />
        </Routes>
      </div>
    </Router>
    </NotificationProvider>
  )
}

export default App
